import {
    IMultiOccurrence,
    IMultiOccurrenceOptions
} from '../../../../../core/services/multi-occurrence.service';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IStateParamsService } from 'angular-ui-router';
import { IMenuClass } from '../../../../../core/services/menu/menu.service';
import { IMenuItemSelectionClass } from '../../../../../core/services/menu/menu-item-selection.service';

interface IPageDO0019 {
    multiOccurrence: IMultiOccurrence;
    multiOccurrenceOptions: IMultiOccurrenceOptions;
}
/* @ngInject */
export default function Do0019Controller(Formulaire: IFormulaireClass,
    $stateParams: IStateParamsService,
    Menu: IMenuClass,
    MenuItemSelection: IMenuItemSelectionClass,
    FormulaireItem: IFormulaireItemClass,
    FormulaireItemSautDeLigne: IFormulaireItemClass) {
    const vm: IPageDO0019 = this;

    vm.multiOccurrenceOptions = {
        fonctions: {
            suiviModification: false,
            criteresSuggeresVisibles: true,
            rechercheCollapsable: false
        },
        actionsSelection: new Menu([
            new MenuItemSelection(
                'LBL_BTN_SELECTION',
                'BOUSEL',
                {
                    selection: { nom: 'selection' }
                })
        ]),
        criteresSuggeres: new Formulaire([
            new FormulaireItem('temcod', { default: $stateParams.temcod + ' ' + $stateParams.temdsc, disabled: true, largeur: 50 }),
            new FormulaireItemSautDeLigne(),
            new FormulaireItem('temcleint', { largeur: 33 }),
            new FormulaireItem('poscleint', { largeur: 33 }),
            new FormulaireItem('offcleint', { largeur: 33 })
        ]),
        colonnesVisibles: [
            { nom: 'gradsc', largeur: 200 },
            { nom: 'tchseqaff', largeur: 140 },
            { nom: 'tchdsc', largeur: 300 }
        ],
        colonnesCachees: ['tchcleint', 'stamnetab', 'tchcleintref']
    };
}
